// Save PDF: the browser prints an unscaled copy of the invoice, which it
// can save as a PDF. The file name comes from the page title.
import { createPortal } from 'react-dom';
import type { Business } from '@/core/business';
import type { Invoice } from '@/core/invoice';
import { InvoicePaper } from '@/invoice/InvoicePaper';
import { t } from '@/l10n/strings';

/** The copy that prints; render it on any page that offers Save PDF. */
export function PrintableInvoice(props: { invoice: Invoice; business: Business; isPro: boolean }) {
  return createPortal(
    <div className="print-copy" aria-hidden>
      <InvoicePaper {...props} />
    </div>,
    document.body,
  );
}

/** Opens the print dialog, titled so a saved PDF is named "Invoice INV-0143". */
export function printInvoice(invoice: Invoice) {
  const title = document.title;
  document.title = t('shareFileName', { number: invoice.number.replace(/[^A-Za-z0-9_-]/g, '-') }).replace(/\.pdf$/, '');
  const restore = () => {
    document.title = title;
    window.removeEventListener('afterprint', restore);
  };
  window.addEventListener('afterprint', restore);
  window.print();
}
